import { render, staticRenderFns } from "./DisputeResponseView.vue?vue&type=template&id=fa47dfe4&"
import script from "./DisputeResponseView.vue?vue&type=script&lang=js&"
export * from "./DisputeResponseView.vue?vue&type=script&lang=js&"
import style0 from "./DisputeResponseView.vue?vue&type=style&index=0&id=fa47dfe4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports